<template>
  <div>
    
    <!-- Purchase Requisition Details Table -->
    <div class="table-container mb-6 mt-0">
        <table class="dep-table details-table mt-5" style="width: 100%; border-collapse: collapse;">
            <thead>
                <tr>
                    <th class="text-center" style="width: 40px; border: 1px solid #000; padding: 2px; font-size: 12px;">SL</th>
                    <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Product Name</th>
                    <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Product Code</th>
                    <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Unit</th>
                    <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Quantity</th>
                    <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Free Quantity</th>
                    <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Price</th>
                    <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Amount</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(detail, index) in purchaseOrderData?.pur_order_details"
                    :key="detail.id">
                    <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ index + 1 }}</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ detail.product?.name }}</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ detail.product?.code }}</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ detail.product?.unit?.name }}</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-size: 12px;">{{ detail?.qty }}</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-size: 12px;">{{ detail?.free_qty }}</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ $numberFormat(detail?.rate) }}</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ $numberFormat(detail?.qty * detail?.rate) }}</td>
                </tr>
                <tr>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px; font-weight: bold;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Subtotal</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ $numberFormat(purchaseOrderData?.sub_total) }}</td>
                </tr>
                <tr>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Discount</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ $numberFormat(purchaseOrderData?.discount_amount) }}</td>
                </tr>
                <tr>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Tax
                      ({{
                        purchaseOrderData?.tax_type === "1"
                        ? "Included"
                        :purchaseOrderData?.tax_type === "2"
                        ? "Excluded"
                        : "Exempted"
                      }})
                    </td>
                    
                    <td style="border: 1px so lid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ $numberFormat(purchaseOrderData?.tax_amount) }}</td>
                </tr>
                <tr>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Vat
                      ({{
                        purchaseOrderData?.vat_type === "1"
                        ? "Included"
                        :purchaseOrderData?.vat_type === "2"
                        ? "Excluded"
                        : "Exempted"
                      }})
                    </td>
                    
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ $numberFormat(purchaseOrderData?.vat_amount) }}</td>
                </tr>
                <tr>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Grand Total</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ $numberFormat(purchaseOrderData?.grand_total) }}</td>
                </tr>
                <tr>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Advance payment</td>
                    <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ purchaseOrderData?.paid }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="amount-in-words-section mb-4" v-if="purchaseOrderData?.grand_total" style="font-size: 12px;">
        <div class="font-weight-bold">
            Amount in Words: <span style="font-weight: normal; text-transform: capitalize;">{{ convertNumberToWords(purchaseOrderData?.grand_total) }}</span>
        </div>
    </div>

    <div v-if="purchaseOrderData?.payment_bank" style="font-size: 12px; margin: 15px 0px; background-color: #ffffff;">
      <p><strong>Wire Transfer to following bank account: </strong></p>
      <table style="border-collapse: collapse;">
        <tbody >
          <tr>
            <td style="border:none; width: 200px;">Account Name</td>
            <td style="border:none;">:{{  purchaseOrderData?.payment_bank?.account_name? `${purchaseOrderData?.payment_bank?.account_name}`: ""  }}</td>
          </tr>
          <tr>
            <td style="border:none;">Account Number</td>
            <td style="border:none;">:{{ purchaseOrderData?.payment_bank?.account_no? `${purchaseOrderData?.payment_bank?.account_no}`: ""  }}</td>
          </tr>
          <tr>
            <td style="border:none;">Name of the Bank</td>
            <td style="border:none;">:{{ purchaseOrderData?.payment_bank?.name? `${purchaseOrderData?.payment_bank?.name}`: ""  }}</td>
          </tr>
          <tr>
            <td style="border:none;">Branch Name</td>
            <td style="border:none;">:{{ purchaseOrderData?.payment_bank?.branch? `${purchaseOrderData?.payment_bank?.branch}`: ""  }}</td>
          </tr>
          <tr>
            <td style="border:none;">Swift Code</td>
            <td style="border:none;">:{{ purchaseOrderData?.payment_bank?.swift_code? `${purchaseOrderData?.payment_bank?.swift_code}`: ""  }}</td>
          </tr>
          <tr>
            <td style="border:none;">Routing No.</td>
            <td style="border:none;">:{{ purchaseOrderData?.payment_bank?.routing_no? `${purchaseOrderData?.payment_bank?.routing_no}`: ""  }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="terms-section mb-4 page-break" v-if="purchaseOrderData?.terms_and_condition">
        <div class="font-weight-bold mb-2">
            Terms and Conditions:
        </div>
        <div class="terms-content" style="color: #000; line-height: 1.4; white-space: pre-wrap;">
            {{ purchaseOrderData.terms_and_condition }}
        </div>
    </div>
      
  </div>
</template>

<script>
import convertNumberToWords from '@/plugins/numberToWord';

export default {
  name: "purchaseOrderDetailsTable",
  data() {
    return {
      purchaseOrderData: null,
      
    };
  },
  
  computed: {},
  watch: {},
  created() {},
  methods: {
    convertNumberToWords,
    getCurrencyIcon(type) {
      return type == 2 ? 'mdi-currency-usd' : 'mdi-currency-bdt'
    },
  },
  setup(props, { emit }) { },
  
  mounted() {
    const id = this.$route.query.referenceable_id;

    this.$store.dispatch('getPurOrderById', id)
      .then((res) => {
        this.purchaseOrderData = res;
      })

  },
};  

</script>

<style scoped>
.full-height {
  min-height: 60vh;
}

.grey-lighten-3 {
  background-color: #eeeeee !important;
}

.report-paper {
  background: white;
}

.company-name {
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
}

.company-text {
  font-size: 14px;
}

.report-title {
  font-size: 20px;
  text-align: center;
  margin: 8px 0;
}

.meta-box {
  border: 1px solid #000 !important;
  padding: 8px;
  font-size: 13px;
  margin: 8px 0;
}

.meta-table {
  width: 100%;
  border-collapse: collapse;
  
}

.dep-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.dep-table th,
.dep-table td {
  border: 1px solid #000;
  padding: 6px;
}

.dep-table th {
  background: #e0e0e0;
}

.total-section {
  margin: 20px 0;
}

.total-table {
  width: 100%;
  margin-bottom: 20px;
}

.remarks-section {
  margin: 20px 0;
  padding: 10px;
  border: 1px solid #ddd;
}

.signature-section {
  margin-top: 50px;
}

.signature-line {
  border-top: 1px solid #555;
  width: 200px;
  margin: 0 auto;
  text-align: center;
  color: #333;
  padding-top: 10px;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.supplier-name {
  font-weight: bold;
}

.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
  opacity: 0.1;
}

.page-header {
  margin-bottom: 20px;
}

.header-section {
  margin-bottom: 20px;
}

.company-info {
  flex: 1;
}

.logo-container {
  flex-shrink: 0;
}

.d-print-none {
  display: block !important;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>